
import { NumberJumpPuzzleData } from "@/models/MapPois/Quest/Puzzle";
import { Quest_CG_MinigameSection } from "@/models/MapPois/Quest/QuestMapPoi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { maxValue, minValue, integer } from "vuelidate/lib/validators";

@Component({
  components: {},
})
class NumberJump extends Vue {
  @Prop({ default: null }) readonly getContentData!: Quest_CG_MinigameSection;
  @Prop({ default: true }) readonly difficultyLevel!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  rounds = 0;
  cells = 0;
  maxRange = 0;

  created(): void {
    this.getNumberJumpPuzzleData();
  }

  getNumberJumpDifficulty(): NumberJumpPuzzleData {
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy === undefined) {
        this.getContentData!.puzzle.puzzleData.easy = this.setNumberJumpData();
      }
      return this.getContentData?.puzzle.puzzleData
        .easy as NumberJumpPuzzleData;
    } else if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard === undefined) {
        this.getContentData!.puzzle.puzzleData.hard = this.setNumberJumpData();
        this.getContentData!.puzzle.puzzleData.hard.onFail = this.getContentData.puzzle.puzzleData.hard.onFail;
        this.getContentData!.puzzle.puzzleData.hard.onSuccess = this.getContentData.puzzle.puzzleData.hard.onSuccess;
        this.getContentData!.puzzle.puzzleData.hard.onIncorrect = this.getContentData.puzzle.puzzleData.hard.onIncorrect;
      }
      return this.getContentData?.puzzle.puzzleData
        .hard as NumberJumpPuzzleData;
    } else {
      if (this.getContentData?.puzzle.puzzleData.default === undefined) {
        this.getContentData!.puzzle.puzzleData.default = this.setNumberJumpData();
      }
      return this.getContentData!.puzzle.puzzleData
        .default as NumberJumpPuzzleData;
    }
  }

  getNumberJumpPuzzleData(): void {
    var data = this.getNumberJumpDifficulty();
    this.rounds = data.numRounds;
    this.cells = data.cells;
    this.maxRange = data.maxRange;
  }
  setNumberJumpPuzzleData(): void {
    try {
      var data = this.getNumberJumpDifficulty();
      data.cells = this.cells;
      data.numRounds = this.rounds;
      data.maxRange = this.maxRange;
      this.$emit("updateData", this.getContentData.puzzle.puzzleData);
    } catch (error) {
      console.log(error);
    }
  }
  setNumberJumpData(): NumberJumpPuzzleData {
    return {
      maxRange: 10,
      numRounds: 5,
      cells: 4,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  @Watch("getContentData")
  getContentDataWatch(): void {
    this.getNumberJumpPuzzleData();
  }
  @Watch("difficultyLevel")
  getdifficultyLevelWatch(): void {
    this.getNumberJumpPuzzleData();
  }

  @Validations()
  validations = {
    rounds: {
      minValue: minValue(1),
      maxValue: maxValue(100),
      integer,
    },
    maxRange: {
      minValue: minValue(10),
      maxValue: maxValue(100),
      integer,
    },
    cells: {
      minValue: minValue(4),
      maxValue: maxValue(12),
      integer,
    },
  };
}
export default NumberJump;
